module.exports = __webpack_public_path__ + "static/media/Postales-02.76174d1f.png";